/** @format */

import { createRoutingAction } from 'utils/routing';

export const GoToNameYourApplicationStep = createRoutingAction('GO_TO_NAME_YOUR_APPLICATION_STEP');
export const GoToCreateApplicationStep = createRoutingAction('GO_TO_CREATE_APPLICATION_STEP');
